
<script>
import { noop, get, inRange, take } from 'lodash'
import DropItem from '@/components/DropDownMenu/DropItem'

export default {
  components: {
    DropItem
  },

  props: {
    placeholder: {
      type: String,
      default: ''
    },
    onSubmit: {
      type: Function,
      default: noop
    },
    onSelect: {
      type: Function,
      default: noop
    },
    multiple: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number
    },

    filter: Object
  },

  data() {
    return {
      FOCUS: null,
      model: '',
      searchStr: '',
      text: 'משרות',
      dropdown: false,
      selected: false      
    }
  },

  computed: {
    focus: {
      get() {
        return this.FOCUS
      },
      set(value) {
        if (value === null) this.FOCUS = value
        else if (this.FOCUS === null) this.FOCUS = 0
        else if (inRange(value, 0, get(this, 'list.length', 0))) {
          this.FOCUS = value
        }

        this.$emit('focus', this.FOCUS)
      }
    },
    value() {
      return this.searchStr
    }
  },

  watch: {
    model(value) {
      if (this.selected && value != this.searchStr) {
        this.unselect()
      }
    }
  },

  methods: {
    open() {
      this.dropdown = true
      this.$emit('open')
    },

    close() {
      this.dropdown = false
      this.$emit('close')
    },

    scroll(direction) {
      try {
        this.focus += direction

        const DropItem = get(this, ['$refs', 'dropdown', this.focus])

        if (!DropItem) return

        const clientHeight = DropItem.$el.parentElement.clientHeight 

        const value = this.focus * clientHeight

        this.$refs.Scrollbar.scrollToY(value)

        this.searchStr = DropItem.$attrs.item.name
      
        this.$emit('scroll', value)
      } catch (e) {
        console.error('[Search] scroll error', e)
      }
    },

    submitSearch(value) {
      this.$props.onSubmit(value)
      this.$emit('submit', value)
    },

    handleSelect(searchStr) {
      this.searchStr = searchStr
      this.model = searchStr
      this.selected = true
      this.$props.onSelect(searchStr)
      this.$emit('select', searchStr)
    },

    unselect() {
      this.selected = false
      this.searchStr = ''
      this.$emit('unselect')
    },

    reset() {
      this.model = ''
      this.searchStr = ''
      this.$emit('reset')
    },

    listFilter(list) {
      return this.max ? take(list, this.max) : list
    }
  }
}
</script>

<style lang="scss" scoped>
div.focus {
  border: 1px solid #bdbdbd;
}

.v-list__tile.focus {
  border: 1px solid #bdbdbd;
}

button.focus {
  border: 1px solid #bdbdbd;
}

.search-res {
  height: 258px;
  object-fit: contain;
  border-radius: 39.5px;
  border: solid 1px #d7d7d7;
  background-color: white;
}

#search-wrap,
.search-wrap {
  position: relative;
  max-width: 630px;
  margin: 0 auto;
  max-height: 66px;
  display: grid;
}

.sticky-layout .search-input-wrap {
  height: 30px;
  padding: 0 5px;
}
.sticky-layout .search-input input {
  padding: 0;
  line-height: 31px;
}

.btn_width {
  width: 95%;
  height: auto;
}

.cat_btn {
  width: 95%;
  height: auto;
}

#my-scrollbar,
.my-scrollbar {
  width: 95%;
  height: auto;
}

.scroll-me {
  min-width: 190px;
}

.vue-scrollbar__scrollbar-vertical {
  width: 5px !important;
}

#my-scrollbar .scrollbar,
.my-scrollbar .scrollbar {
  background: $primary;
}

#my-scrollbar .scrollbar,
.my-scrollbar .scrollbar {
  width: 5px !important;
  background: #f6f7f9;
}

#my-scrollbar .vue-scrollbar__scrollbar-vertical .scrollbar,
.my-scrollbar .vue-scrollbar__scrollbar-vertical .scrollbar {
  width: 5px;
}

@media screen and (min-width: 600px) {
  #home-search .search-input-wrap {
    padding: 10px 5px;
  }
  .sticky-layout .search-input-wrap {
    height: auto;
    padding: 4px 5px;
  }

  .icon-forma-1-copy-4 {
    height: 100%;
  }
}

.search-input-wrap .search-input ::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: $primary;
  opacity: 1;
  /* Firefox */
}
.search-input-wrap .theme--light.v-icon {
  color: $primary;
}
</style>
